// extracted by mini-css-extract-plugin
module.exports = {"header":"NearByStore_header__3rFK6","footer":"NearByStore_footer__2iKGw","content":"NearByStore_content__1I_eL"};